<template>
  <div class="card-form">
      <page-main
        :tableData="tableData"
        :tablePage="page"
        :loading="loading"
        @reload="reload"
        @openEditFormDialog="openEditFormDialog"
      >
        <page-header
          ref="header"
          slot="header"
          @query="getData"
          @reset="resetPage"
          @openEditFormDialog="openEditFormDialog"
        />
        <pagination
          size="mini"
          align="right"
          slot="pager"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </page-main>
      <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="700px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
      >
        <edit-form
          ref="editForm"
          :fabricAttrCode="editFormDialogOptions.fabricAttrCode"
          :fabricAttrTypeEn="editFormDialogOptions.fabricAttrTypeEn"
          :fabricAttrTypeCn="editFormDialogOptions.fabricAttrTypeCn"
          :disabled="editFormDialogOptions.disabled"
          :createDateVisible="editFormDialogOptions.createDateVisible"
          :params="editFormDialogOptions.params"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()"
            >{{this.$l('INDEX.btn_cancel') || '取消'}}</el-button
          >
          <el-button type="primary" size="small" @click="$refs.editForm.save()"
          v-if="!editFormDialogOptions.disabled"
            >{{this.$l('INDEX.btn_save') || '保存'}}</el-button
          >
        </span>
      </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../right-edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  computed: {
    selected() {
      return store.state.selected
    },
  },
  watch: {
    selected() {
      this.getData()
    },
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.value) return
      this.loading = true
      this.$api
        .masterFabricAttributesListApi({
          fabricAttrTypeEn: this.selected.value,
          fabricAttrStatusList: ['Y'],
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, params = {}}) {
      if (!this.selected || !this.selected.value) {
        this.$message.warning(this.$l('form_label_tip_select_category') ||'请选选择一个大类')
        return
      }
      const types = {
        edit: this.$l("tips_add") || "编辑面料属性信息",
        add: this.$l("tips_edit") || "增加面料属性信息",
        detail: this.$l("tips_view") || "面料属性详情",
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        fabricAttrCode: params.fabricAttrCode,
        fabricAttrTypeEn: this.selected.value,
        fabricAttrTypeCn: this.selected.label,
        disabled: type === "detail",
        createDateVisible: type != "add",
        params:params,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
